export default function FilterOption({
  name,
  className,
  children,
}: {
  name: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={`text-white text-sm bg-[#121212] border-b border-[#4B4B4B] w-full py-2 px-6 md:px-24 mb-4 ${className}`}
    >
      <h3 className="pb-4">{name}</h3>
      {children}
    </div>
  );
}
